/**
 * 转换字体样式
 * CMS配置的字体大小基于mobile配置的
 * 一般来说，PC的字体要大于mobile
 * 这里定义的规则是：PC字体、间距是mobile的1.5倍
 */
/**
 * 间距
 */
export function transformInterval(size, isMobile, type) {
  var withPx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var ratio;
  switch (type) {
    case 'proudcCard':
      ratio = isMobile ? 1 : 1.5;
      break;
    case 'photoAds':
      ratio = isMobile ? 1 : 1.5;
      break;
    default:
      ratio = isMobile ? 1 : 1.5;
      break;
  }
  if (withPx) {
    return "".concat(size * ratio, "px");
  }
  return size * ratio;
}
/**
 * 页边距
 */
export function transformPageMargins(size, isMobile) {
  var withPx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var ratio = isMobile ? 1 : 10;
  if (withPx) {
    return "".concat(size * ratio, "px");
  }
  return size * ratio;
}
export function transformUnit(size, isMobile) {
  var withPx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var ratio = isMobile ? 1 : 1.2;
  if (withPx) {
    return "".concat(size * ratio, "px");
  }
  return size * ratio;
}
export function transformFontsize(size, isMobile) {
  return transformUnit(size, isMobile);
}
export function transformSpacing(size, isMobile) {
  var ratio = isMobile ? 1 : 1.5;
  return "0 ".concat(size * ratio, "px");
}
export function transformStyle(style, isMobile) {
  var newStyle = Object.assign({}, style);
  for (var key in newStyle) {
    var value = newStyle[key];
    if (key === 'padding') {
      newStyle[key] = "0 ".concat(transformPageMargins(value, isMobile));
    }
    if (key === 'fontSize') {
      newStyle[key] = transformFontsize(value, isMobile);
    }
  }
  return newStyle;
}
export function isClickable(target) {
  return target && target.linkType !== 'none';
}